import { salesApi } from '../config/apiClient';

// ============================================
// ÜRÜN SATIŞ ÖZETİ (GÜN SONU RAPORU İÇİN)
// ============================================

export interface ProductSalesSummaryItem {
  ProductName: string;
  UnitPrice: number;
  TotalQuantity: number;
  TotalAmount: number;
}

export interface ProductSalesSummaryResponse {
  Success: boolean;
  Message?: string;
  Items: ProductSalesSummaryItem[];
  GrandTotal: number;
  TotalProductCount: number;
}

// ============================================
// ÜRÜN SATIŞ ÖZETİ API ÇAĞRISI
// ============================================

export async function getProductSalesSummary(
  companyId: string,
  startDate: string,
  endDate: string,
  branchId?: string | null
): Promise<ProductSalesSummaryResponse> {
  try {
    const params = new URLSearchParams({
      companyId,
      startDate,
      endDate,
    });
    
    if (branchId) {
      params.append('branchId', branchId);
    }
    
    console.log('[productSalesSummaryApi] 📊 getProductSalesSummary çağrıldı:', { companyId, startDate, endDate, branchId });
    
    const response = await salesApi.get<ProductSalesSummaryResponse>(
      `/api/QuickSaleWithInvoice/product-sales-summary?${params.toString()}`
    );
    
    console.log('[productSalesSummaryApi] ✅ getProductSalesSummary yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[productSalesSummaryApi] ❌ getProductSalesSummary HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Ürün satış özeti alınamadı',
      Items: [],
      GrandTotal: 0,
      TotalProductCount: 0
    };
  }
}

// ============================================
// ✅ YENİ: Invoice ID listesine göre ürün satış özeti
// Gün sonu raporu yazdırma için - filtrelenen fişlerin faturalarından ürün çeker
// ============================================

export async function getProductSalesSummaryByInvoiceIds(
  invoiceIds: string[]
): Promise<ProductSalesSummaryResponse> {
  try {
    if (!invoiceIds || invoiceIds.length === 0) {
      console.log('[productSalesSummaryApi] ⚠️ Invoice ID listesi boş');
      return {
        Success: true,
        Message: 'Fatura bulunamadı',
        Items: [],
        GrandTotal: 0,
        TotalProductCount: 0
      };
    }
    
    console.log('[productSalesSummaryApi] 📊 getProductSalesSummaryByInvoiceIds çağrıldı:', { 
      invoiceCount: invoiceIds.length,
      sampleIds: invoiceIds.slice(0, 3)
    });
    
    const response = await salesApi.post<ProductSalesSummaryResponse>(
      `/api/QuickSaleWithInvoice/product-sales-summary-by-invoices`,
      invoiceIds
    );
    
    console.log('[productSalesSummaryApi] ✅ getProductSalesSummaryByInvoiceIds yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[productSalesSummaryApi] ❌ getProductSalesSummaryByInvoiceIds HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Ürün satış özeti alınamadı',
      Items: [],
      GrandTotal: 0,
      TotalProductCount: 0
    };
  }
}

// ============================================
// Invoice Number listesine göre ürün satış özeti (Restoran satışları için)
// ============================================

export async function getProductSalesSummaryByInvoiceNumbers(
  invoiceNumbers: string[]
): Promise<ProductSalesSummaryResponse> {
  try {
    if (!invoiceNumbers || invoiceNumbers.length === 0) {
      return {
        Success: true,
        Message: 'Fatura numarası bulunamadı',
        Items: [],
        GrandTotal: 0,
        TotalProductCount: 0
      };
    }
    
    console.log('[productSalesSummaryApi] 📊 getProductSalesSummaryByInvoiceNumbers çağrıldı:', { 
      count: invoiceNumbers.length,
      sample: invoiceNumbers.slice(0, 3)
    });
    
    const response = await salesApi.post<ProductSalesSummaryResponse>(
      `/api/QuickSaleWithInvoice/product-sales-summary-by-invoice-numbers`,
      invoiceNumbers
    );
    
    console.log('[productSalesSummaryApi] ✅ getProductSalesSummaryByInvoiceNumbers yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[productSalesSummaryApi] ❌ getProductSalesSummaryByInvoiceNumbers HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Ürün satış özeti alınamadı',
      Items: [],
      GrandTotal: 0,
      TotalProductCount: 0
    };
  }
}
